$(document).ready(function () {
  // Used for scrolling down
  $("a[href='#bottom']").click(function() {
    $("body,html").animate({ scrollTop: $('.js-scrollTarget').offset().top }, "slow");
    return false;
  });
});
